import { render, staticRenderFns } from "./sellAdd copy.vue?vue&type=template&id=5c4aa5c4&scoped=true"
import script from "./sellAdd copy.vue?vue&type=script&lang=js"
export * from "./sellAdd copy.vue?vue&type=script&lang=js"
import style0 from "./sellAdd copy.vue?vue&type=style&index=0&id=5c4aa5c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4aa5c4",
  null
  
)

export default component.exports